import React from 'react';

interface Props {
    size?: 'xs' | 'sm' | 'md' | 'lg';
    className?: string;
}

export default function SquareLoader({ size = 'sm', className = '' }: Props) {
    const sizeClass =
        size === 'xs' ? 'gv-square-xs' : size === 'lg' ? 'gv-square-lg' : size === 'md' ? 'gv-square-md' : 'gv-square-sm';
    return (
        <span className={`gv-square-loader ${sizeClass} ${className}`}>
            <span className="gv-square" />
            <span className="gv-square delay-150" />
            <span className="gv-square delay-300" />
        </span>
    );
}
